import { memo, type ReactElement } from 'react';
import { type SvgIconProps } from '@mui/material';

import { ICONS, type IconName } from './icons';

type Props = SvgIconProps & {
  icon?: IconName | null;
};

function IconComponent({ icon, ...props }: Props): ReactElement | null {
  if (!icon) {
    return null;
  }

  const Component = ICONS[icon];

  return <Component {...props} />;
}

export const Icon = memo(IconComponent);
